import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
// ... existing imports ...

const QuantityAdjuster = ({ quantity, adjustQuantity, handleDecrement, handleIncrement, customStyles = {} }) => {
  const [localQuantity, setLocalQuantity] = useState(quantity);

  useEffect(() => {
    setLocalQuantity(quantity);
  }, [quantity]);

  const defaultStyles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1px',
    },
    button: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      height: '44px',
      padding: '0px 18px',
      borderRadius: '9px',
      border: '2px solid #1C124D',
    },
    text: {
      color: '#1C124D',
      fontSize: '24px',
    },
    display: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '7px 12px',
      background: '#F5F4F9',
    },
  };

  const handleChange = (change) => {
    const newQuantity = Math.max(0, localQuantity + change);
    setLocalQuantity(newQuantity);
    adjustQuantity(newQuantity);
  };

  return (
    <Box
      sx={{
        ...defaultStyles.container,
        ...customStyles.container,
      }}
    >
      <Box
        id="quantity-decrement"
        sx={{
          ...defaultStyles.button,
          ...customStyles.button,
          borderTopLeftRadius: '9px',
          borderBottomLeftRadius: '9px',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        onClick={() => {
          if (handleDecrement) handleDecrement();
          handleChange(-1);
        }}
      >
        <Typography sx={{ ...defaultStyles.text, ...customStyles.text }}>-</Typography>
      </Box>
      <Box
        id="quantity-display"
        sx={{
          ...defaultStyles.display,
          ...customStyles.display,
        }}
      >
        <Typography sx={{ ...defaultStyles.text, ...customStyles.text }}>{localQuantity}</Typography>
      </Box>
      <Box
        id="quantity-increment"
        sx={{
          ...defaultStyles.button,
          ...customStyles.button,
          borderTopRightRadius: '9px',
          borderBottomRightRadius: '9px',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
        }}
        onClick={() => {
          if (handleIncrement) handleIncrement();
          handleChange(1);
        }}
      >
        <Typography sx={{ ...defaultStyles.text, ...customStyles.text }}>+</Typography>
      </Box>
    </Box>
  );
};

// ... existing MealInfoCard component ...

export default QuantityAdjuster;
